import { render, staticRenderFns } from "./EssayTextArea.vue?vue&type=template&id=37e4def8&scoped=true&"
import script from "./EssayTextArea.vue?vue&type=script&lang=js&"
export * from "./EssayTextArea.vue?vue&type=script&lang=js&"
import style0 from "./EssayTextArea.vue?vue&type=style&index=0&id=37e4def8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4def8",
  null
  
)

component.options.__file = "EssayTextArea.vue"
export default component.exports